import i18n from '../../utils/i18n';

export const buildVinNomNote = inputParametersSD => {
	const vinNom =
		'*' +
		i18n.t('components.charts.utils.vinNom.beginning') +
		' (' +
		inputParametersSD.vinNom +
		' V) ' +
		i18n.t('components.charts.utils.vinNom.end');
	const vinMin = ' ' + i18n.t('components.charts.utils.vinMin') + ' (' + inputParametersSD.vinMin + ' V)';
	const vinMax =
		' ' +
		i18n.t('components.charts.utils.vinMax.beginning') +
		' (' +
		inputParametersSD.vinMax +
		' V) ' +
		i18n.t('components.charts.utils.vinMax.end') +
		'.';

	return vinNom.concat(vinMin, vinMax);
};

export const getStrForInputParams = str => {
	if (str.includes('Rms')) {
		return str
			.replace('Rms', ' ')
			.toLowerCase()
			.split(' ')
			.map((word, idx) => (idx === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
			.join('');
	}
	return str;
};
